(function ($) {
  Drupal.behaviors.ehThewinkHpRedesignTopStoriesV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-thewink-hp-redesign-top-stories-v1', context);

      formatter.each(function () {
        var thisFormatter = $(this);

        // Lazyload
        site.util.lazyLoaded(thisFormatter);
      });
    }
  };
})(jQuery);
